
export default {
  name: 'SectionsYoutubeVideo',
  props: {
    youtubeVideo: {
      type: Object,
      default: () => ({}),
    },
  },
}
